import Api from '@common/services/api';
import { StoreState } from '@common/types/store';
import { ThunkAction } from 'redux-thunk';

interface Timeline {
  id: string;
  type: 'network';
}

interface HighFivePayload {
  recipient_user_id: string;
  timeline?: Timeline;
  text: string;
  values?: string[];
}

type SendHighFiveAction = {
  type: 'recognitions/SEND_HIGH_FIVE';
  item: any;
};

type ActualSendHighFiveAction = ThunkAction<
  Promise<SendHighFiveAction>,
  StoreState,
  unknown,
  SendHighFiveAction
>;

export const sendHighFive =
  (payload: Partial<HighFivePayload>): ActualSendHighFiveAction => async (dispatch, getState) => {
    const {
      organisation: { selected },
    } = getState();

    const { data: item } = await Api.post(
      `/v1/organisations/${selected.id}/recognitions`,
      payload
    );

    return dispatch({
      type: 'recognitions/SEND_HIGH_FIVE',
      item,
    });
  };
